import rawData from "../data/nearbyguide.json";

let SEARCH_INDEX = null;

export const buildSearchIndex = () => {
  if (SEARCH_INDEX) return SEARCH_INDEX;

  const index = [];

  Object.entries(rawData.cities).forEach(([cityKey, cityData]) => {
    Object.entries(cityData).forEach(([categoryKey, list]) => {
      if (!Array.isArray(list)) return;

      list.forEach((item) => {
        index.push({
          city: cityKey,
          category: categoryKey,
          name: item.name || "",
          area: item.area || "",
          details: item.details || "",
          map: item.map || "",
          slug: (item.name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-"),
          featured: item.featured || false,
        });
      });
    });
  });

  SEARCH_INDEX = index;
  return index;
};
